import type { FC } from "react";
import {
  CounterInput,
  Article,
  Flex,
  Image,
  Separator,
  TextBody,
  TextSubtitle,
  cn,
} from "@/ui";
import {
  FRESH_PRODUCT_CARD_CLASS,
  FRESH_PRODUCT_CARD_CONTENT_CLASS,
  FRESH_PRODUCT_CARD_DEFAULTS,
  FRESH_PRODUCT_CARD_IMAGE_CLASS,
  type TFreshProductCardProps,
} from "./FreshProductCard.config";

export const FreshProductCard: FC<TFreshProductCardProps> = ({
  title,
  body,
  image,
  counterInput,
  className,
  "data-component": component = FRESH_PRODUCT_CARD_DEFAULTS["data-component"],
  ...props
}) => (
  <Article
    {...props}
    data-component={component}
    className={cn(
      FRESH_PRODUCT_CARD_CLASS,
      className,
    )}
  >
    <Flex className={FRESH_PRODUCT_CARD_IMAGE_CLASS}>
      <Image {...image} fit="cover" className="h-full" />
    </Flex>

    <Flex
      direction="column"
      gap="2"
      className={FRESH_PRODUCT_CARD_CONTENT_CLASS}
    >
      <Flex direction="column" className="px-4">
        <TextSubtitle tag="h3" size={3} isResponsive={false}>
          { title }
        </TextSubtitle>
        <Separator className="mt-1" />
      </Flex>

      <Flex className="px-4">
        <TextBody size={3} isResponsive={false}>
          { body }
        </TextBody>
      </Flex>

      <Flex justify="end" className="mt-auto px-2">
        <CounterInput {...counterInput} />
      </Flex>
    </Flex>
  </Article>
);

FreshProductCard.displayName = "FreshProductCard";
